var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-container", [
    _c("h1", { staticClass: "text-center" }, [
      _vm._v("Hello project detail " + _vm._s(_vm.ProjectID)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/project/project.detail.vue